import { createInstance, type Client } from '@optimizely/optimizely-sdk'
let optimizelyClient: Client | null = null

// ! For use Server Side Only!
export const initializeOptimizelyClient = async (): Promise<Client | null> => {
  if (!optimizelyClient) {
    optimizelyClient = createInstance({ sdkKey: process.env.OPTIMIZELY_NPO_FRONTEND_SDK_KEY })
  }

  try {
    await optimizelyClient?.onReady({ timeout: 5000 })
  } catch (error) {
    console.info('Optimizely SDK failed to load:', error)
    optimizelyClient = null
  }

  return optimizelyClient
}
